import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';
import { cancelTradeRequest } from '../../../actions/tradeOffersActions';

class CancelTradeRequestModal extends React.Component {
    _handleHideModal = () => {
      const { hideTooltip, id } = this.props;

      hideTooltip(id);
    };

    _handleCancelTradeRequest = () => {
      const { tradeOfferId, tradeRequestReject } = this.props;

      tradeRequestReject(tradeOfferId);
    };

    componentWillUnmount() {
      this._handleHideModal();
    }

    render() {
      const { id } = this.props;

      return (
        <Modal id={ id }>
          <div className='modal__header'>
                    Are you sure?
          </div>

          <div>
                    Are you sure you want to cancel this trade request?
          </div>

          <div className='modal__actions'>
            <Button className='form__button form__button--purple'  onClick={ this._handleCancelTradeRequest } type='button'>Yes</Button>
            <Button className='form__button form__button--green' onClick={ this._handleHideModal } type='button'>No</Button>
          </div>
        </Modal>
      );
    }
}

CancelTradeRequestModal.propTypes = {
  hideTooltip: PropTypes.func.isRequired,
  id: PropTypes.string,
  tradeRequestReject: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideTooltip: (id) => dispatch(tooltipHide({ id })),
    tradeRequestReject: (tradeOfferId) => dispatch(cancelTradeRequest({ tradeOfferId }))
  };
};

export default connect(null, mapDispatchToProps)(CancelTradeRequestModal);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/CancelTradeRequestModal.jsx